export const TASK_VALUE_TYPE = {
	BUYER_SAMPLE_REVIEW: 'BUYER_SAMPLE_REVIEW',
	CONFIRMED_BY_BUYER: 'CONFIRMED_BY_BUYER',
	COSTING_CLOSED_WITHOUT_ORDER: 'COSTING_CLOSED_WITHOUT_ORDER',
	FACTORY_DEVELOPMENT_CLOSED_WITHOUT_ORDER: 'FACTORY_DEVELOPMENT_CLOSED_WITHOUT_ORDER',
	FACTORY_DEVELOPMENT_REVIEW_BY_GT: 'FACTORY_DEVELOPMENT_REVIEW_BY_GT',
	IN_HOUSE_DEVELOPMENT_CLOSED_WITHOUT_ORDER: 'IN_HOUSE_DEVELOPMENT_CLOSED_WITHOUT_ORDER',
	IN_HOUSE_DEVELOPMENT_REVIEW_BY_BUYER: 'IN_HOUSE_DEVELOPMENT_REVIEW_BY_BUYER',
	IN_HOUSE_DEVELOPMENT_REVIEW_BY_GT: 'IN_HOUSE_DEVELOPMENT_REVIEW_BY_GT',
	IN_HOUSE_SAMPLE_DEVELOPMENT_START: 'IN_HOUSE_SAMPLE_DEVELOPMENT_START',
	ORDER_FIT_SAMPLE_REVIEW_BY_GT: 'ORDER_FIT_SAMPLE_REVIEW_BY_GT',
	ORDER_PP_SAMPLE_REVIEW_BY_GT: 'ORDER_PP_SAMPLE_REVIEW_BY_GT',
	ORDER_SAMPLE_REVIEW: 'ORDER_SAMPLE_REVIEW',
	PARTIAL_FACTORY_SAMPLE_DEVELOPMENT: 'PARTIAL_FACTORY_SAMPLE_DEVELOPMENT',
	PARTIAL_IN_HOUSE_SAMPLE_DEVELOPMENT: 'PARTIAL_IN_HOUSE_SAMPLE_DEVELOPMENT',
	PRESENTED_TO_BUYER: 'PRESENTED_TO_BUYER',
	SAMPLE_HANDOVER_TO_OWNER_PLANNING: 'SAMPLE_HANDOVER_TO_OWNER_PLANNING',
	SAMPLE_REVIEW_BY_PD: 'SAMPLE_REVIEW_BY_PD',
	SAMPLE_REVIEW_QC: 'SAMPLE_REVIEW_QC',
	SAMPLE_REVIEW_TP_OWNER: 'SAMPLE_REVIEW_TP_OWNER',
	SAMPLE_SEWING: 'SAMPLE_SEWING',
	SELECTED_BY_BUYER: 'SELECTED_BY_BUYER',
	DESIGN_REVIEW_BY_TEAM_LEAD: 'DESIGN_REVIEW_BY_TEAM_LEAD',
	ASSIGN_PATTERN_MASTER: 'ASSIGN_PATTERN_MASTER',
	ASSIGN_SEWING_MAN: 'ASSIGN_SEWING_MAN',
	CONNECT_PRODUCT_TO_DEAL: 'CONNECT_PRODUCT_TO_DEAL',
	NEED_PD_COMMERCIAL_APPROVAL: 'NEED_PD_COMMERCIAL_APPROVAL',
	/** Backend uses two underscores before `REVIEW`. */
	SHIPMENT_SAMPLE__REVIEW: 'SHIPMENT_SAMPLE__REVIEW',
	SHIPMENT_SAMPLE_REVIEW: 'SHIPMENT_SAMPLE_REVIEW',
	TASK_PRIORITY_UPDATE: 'TASK_PRIORITY_UPDATE'
};
